import { Component, inject, Input } from '@angular/core';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Portals } from '@qwyk/models';
import { QuotationsFacade } from '@qwyk/shared-stores/quotations';
import { SimpleModalComponent } from '@qwyk/ui-standalone';

import { QuotationsService } from '../../services/quotations.service';

@Component({
    selector: 'qwyk-quotation-rate-requests-list',
    templateUrl: './quotation-rate-requests-list.component.html',
    styleUrls: ['./quotation-rate-requests-list.component.scss'],
    providers: [DialogService],
})
export class QuotationRateRequestsListComponent {

    private modal = inject(DialogService);
    private service = inject(QuotationsService);
    private quotations = inject(QuotationsFacade);

    @Input() rateRequests: Portals.QuotationRateRequest[];
    @Input() outbound = false;

    public ref: DynamicDialogRef | undefined;

    public closeRequest(rateRequest: Portals.QuotationRateRequest) {
        this.ref = this.modal.open(SimpleModalComponent, {
            position: 'center',
            showHeader: false,
            closable: true,
            width: '50%',
            contentStyle: {
                'padding': 0
            },
            data: {
                header:  'Close Rate Request without Offer',
                dismissAction:  'Cancel',
                confirmAction:  'Continue',
                inputLabel:  'Provide a close reason:',
                showInput:  true,
                inputType:  'textarea',
                inputPlaceholder:  'Close reason...',
                inputRequired:  true
            }
        });

        this.ref.onClose.subscribe((reason) => {
            if (reason) {
                const sub = this.service
                    .closeQuotationRateRequest(rateRequest, { reason })
                    .subscribe({
                        next: (quotation) => {
                            this.quotations.quotationUpdated(quotation);
                            if (sub) {
                                sub.unsubscribe();
                            }
                        },
                        error: () => {
                            alert(
                                'Something went wrong, please try again or contact support if the problem persists.'
                            );
                            if (sub) {
                                sub.unsubscribe();
                            }
                        }
                    });
            }
        });
    }
}
